import { Controller } from "@hotwired/stimulus"

// TypedConfirm.js: il pulsante di conferma si attiva solo quando il testo scritto (senza spazi ai lati) è la parola
// esatta; disattivato durante l'invio; alla chiusura della finestra il testo si azzera.
export default class extends Controller {
  static targets = ["input", "go"]
  static values = { word: String }

  connect() { this.verifica() }

  verifica() {
    this.goTarget.disabled = this.busy || this.inputTarget.value.trim() !== this.wordValue.trim()
  }

  inizio() {
    this.busy = true
    this.verifica()
  }

  fine() {
    this.busy = false
    this.verifica()
  }

  azzera() {
    if (this.element.closest("[data-controller~='dialog']")?.dataset.state === "open") return
    this.inputTarget.value = ""
    this.verifica()
  }
}
